/* import __COLOCATED_TEMPLATE__ from './connection-controls.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type { WebsocketState } from 'embercom/services/fin-voice-service';
import type FinVoiceService from 'embercom/services/fin-voice-service';
export interface ConnectionControlsArgs {
  connectionState: WebsocketState;
  isMuted: boolean;
  hasSessions: boolean;
  showTextMessageInput: boolean;
  selectedNumberConfigurationPhoneNumberId: string | undefined;
  isLoading: boolean;
  isDocked?: boolean;
  selectConfig?: (phoneNumber: string | undefined) => void;
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
  mute: () => void;
  unmute: () => void;
  clearAllSessions: () => void;
  getFrequencyData: () => { values: Float32Array };
  sendTextMessage: (message: string) => void;
}

interface Signature {
  Args: ConnectionControlsArgs;
  Element: HTMLElement;
}

export default class ConnectionControls extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare finVoiceService: FinVoiceService;
  @service declare finVoiceConfigService: FinVoiceConfigService;

  get selectedNumberConfigurationName() {
    if (this.args.selectedNumberConfigurationPhoneNumberId) {
      return this.finVoiceConfigService.phoneNumbers[
        this.args.selectedNumberConfigurationPhoneNumberId
      ]?.name;
    }

    return undefined;
  }

  get selectedNumberNumber() {
    if (this.args.selectedNumberConfigurationPhoneNumberId) {
      return this.finVoiceConfigService.phoneNumbers[
        this.args.selectedNumberConfigurationPhoneNumberId
      ]?.phoneNumber;
    }

    return undefined;
  }

  get isConnected() {
    return this.args.connectionState === 'connected';
  }

  get isConnecting() {
    return this.args.connectionState === 'connecting';
  }

  get isDisconnecting() {
    return this.args.connectionState === 'disconnecting';
  }

  get isDisconnected() {
    return this.args.connectionState === 'disconnected';
  }

  get isActiveConnection() {
    return this.isConnected || this.isConnecting;
  }

  get buttonText() {
    switch (this.args.connectionState) {
      case 'connected':
      case 'connecting':
        return this.intl.t('ai-agent.voice-playground.disconnect');
      default:
        return this.intl.t('ai-agent.voice-playground.connect');
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConnectionControls': typeof ConnectionControls;
  }
}
